import { useEffect } from 'react';
import { useNavbar } from '@app/atoms/app/navbar.atom.ts';
import { PharmacyCard } from '@ui/checkout/pharmacy-card';
import { useNavigate } from 'react-router-dom';
import { Divider } from '@heroui/react';
import { useStoresList } from '../../entites/store/use-stores-list.ts';
import { useAtomValue, useAtom } from 'jotai/index';
import { cityAtom } from '@app/atoms/app/city.atom.ts';
import {
  checkoutAtom,
  productsAtom,
} from '../../entites/cart/use-cart-products.store.ts';
import { ProductStatusProps } from '@ui/product/product-status.tsx';

export const PharmacyPage = () => {
  const set = useNavbar();
  const navigate = useNavigate();
  const city = useAtomValue(cityAtom);
  const cart = useAtomValue(productsAtom);
  const [checkout, setCheckout] = useAtom(checkoutAtom);
  const { rawData = [] } = useStoresList({
    selectedProductId: cart.map((i) => i.id),
    selectedCityId: city.id,
  });

  const pharmaciesWithAvailableProducts = rawData.map((pharmacy) => {
    return {
      pharmacy: {
        id: pharmacy.id,
        address: pharmacy.address,
        name: `Аптека №${pharmacy.id}`,
        variant: checkout.pharmacyId === pharmacy.id ? 'info' : 'select',
        statuses: [
          { variant: 'open', children: 'Открыто с 10:00 до 00:00' },
          { variant: 'available' },
        ] as ProductStatusProps[],
      },
      available: pharmacy,
    } as const;
  });

  // const availableProductsList = data.filter((product) => data.);

  useEffect(() => {
    set.pharmacy();
  }, []);

  return (
    <div className="flex flex-col gap-y-4 pt-4 pb-12">
      {pharmaciesWithAvailableProducts?.map((item, index) => {
        return (
          <div key={index}>
            <PharmacyCard
              {...item.pharmacy}
              onPress={() => {
                setCheckout((s) => ({
                  ...s,
                  pharmacyId: item.pharmacy.id,
                }));
                navigate(-1);
              }}
              // onPress={() => navigate(`/pharmacy/1/availability`)}
            />

            {index + 1 !== pharmaciesWithAvailableProducts.length && (
              <Divider />
            )}
          </div>
        );
      })}
    </div>
  );
};
